import React from 'react';

import IconGripVertical from 'ui/icons/GripVertical';

import { DATA_TEST_IDS } from '../consts';
import styles from '../index.module.scss';
import { VideoMediaUploaderItemProps } from './types';

const VideoMediaUploaderItem: React.FC<VideoMediaUploaderItemProps> = ({
  item,
  sortableId,
  elementId,
  isLoading,
  isDragHandleVisible,
  onRemove,
  onRetry,
  renderer: MediaListRenderer,
  postfix: MediaListRendererChildren,
}) => {
  const isRemoveVisible = !item.error && !isLoading;
  const childrenClassName = item.error ? `${styles.children} ${styles.childrenError}` : styles.children;

  return (
    <li
      data-id={sortableId}
      className={isDragHandleVisible ? `${styles.line} ${styles.sortableLine}` : styles.line}>
      {isDragHandleVisible && (
        <div
          className={styles.dragHandle}
          data-testid={DATA_TEST_IDS.DRAG_HANDLE(elementId, item.value.id)}>
          <IconGripVertical />
        </div>
      )}
      <MediaListRenderer
        isCompact
        title={item.label}
        uploading={item.isLoading}
        extension={item.value?.extension}
        imgLink={item.value?.previewUrl || item.value?.imgLink}
        duration={item.value.duration}
        error={item.error}
        url={item.value?.url}
      />
      {MediaListRendererChildren && (
        <div className={childrenClassName}>
          <MediaListRendererChildren
            id={elementId}
            isRemove={isRemoveVisible}
            isError={item.error}
            onRemove={() => onRemove(item.value)}
            onRetry={() => onRetry(item.value)}
            isMultiple
          />
        </div>
      )}
    </li>
  );
};

export default VideoMediaUploaderItem;
